// Velaine: upsell-carrousel in de winkelwagen (drawer). Markup en stijl: snippets/velaine-cart-upsell.liquid.
// Staat als los bestand in de header, zodat het ook werkt als het drawer later wordt ververst.
(() => {
  if (customElements.get('velaine-cart-upsell')) return;
  customElements.define(
    'velaine-cart-upsell',
    class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.addEventListener(
          'click',
          (event) => {
            const target = event.target instanceof Element ? event.target : null;
            if (!target) return;
            if (target.closest('[data-vl-up-prev]')) this.go(-1);
            else if (target.closest('[data-vl-up-next]')) this.go(1);
            else if (target.closest('[data-vl-up-add]')) this.add(target.closest('[data-vl-up-add]'));
          },
          { signal }
        );
        this.addEventListener(
          'change',
          (event) => {
            const select = event.target;
            if (select instanceof HTMLSelectElement && select.matches('[data-vl-up-select]')) {
              this.update(select.closest('[data-vl-up-card]'));
            }
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      go(direction) {
        const track = this.querySelector('[data-vl-up-track]');
        if (!track) return;
        const width = track.clientWidth;
        const max = track.scrollWidth - width;
        let left = Math.round(track.scrollLeft / width) * width + direction * width;
        if (left > max + 5) left = 0;
        if (left < -5) left = max;
        track.scrollTo({ left, behavior: 'smooth' });
      }

      variants(card) {
        try {
          return JSON.parse(card.querySelector('[data-vl-up-variants]').textContent);
        } catch (error) {
          return [];
        }
      }

      values(card) {
        return [...card.querySelectorAll('[data-vl-up-select]')].map((select) => select.value);
      }

      update(card) {
        if (!card) return;
        this.message(card, '');
        const values = this.values(card);
        const match = this.variants(card).find((variant) =>
          values.every((value, index) => !value || variant.options[index] === value)
        );
        if (!match) return;
        const image = card.querySelector('[data-vl-up-img]');
        if (image && match.image) image.src = match.image;
        const price = card.querySelector('[data-vl-up-price]');
        if (price && match.sale) price.textContent = match.sale;
        const compare = card.querySelector('[data-vl-up-compare]');
        if (compare && match.price) compare.textContent = match.price;
      }

      message(card, text) {
        const box = card.querySelector('[data-vl-up-msg]');
        if (!box) return;
        box.textContent = text;
        box.hidden = !text;
      }

      async add(button) {
        if (this.busy) return;
        const card = button.closest('[data-vl-up-card]');
        if (!card) return;
        const selects = [...card.querySelectorAll('[data-vl-up-select]')];
        const missing = selects.find((select) => !select.value);
        if (missing) {
          const name = missing.closest('label')?.querySelector('.vl-up__opt-name')?.textContent || 'optie';
          this.message(card, `Kies eerst je ${name.toLowerCase()}.`);
          missing.focus();
          return;
        }
        const values = this.values(card);
        const variant = selects.length
          ? this.variants(card).find((v) => values.every((value, index) => v.options[index] === value))
          : { id: Number(button.dataset.variantId), available: true };
        if (!variant || !variant.available) {
          this.message(card, 'Deze keuze is helaas uitverkocht. Kies een andere.');
          return;
        }

        const sections = [...document.querySelectorAll('cart-items-component')]
          .map((element) => element.dataset.sectionId)
          .filter(Boolean);
        const root = window.Shopify?.routes?.root || '/';
        this.busy = true;
        button.setAttribute('aria-busy', 'true');
        this.message(card, '');
        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }], sections: sections.join(',') }),
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            this.message(card, data.description || data.message || 'Toevoegen lukte niet. Probeer het opnieuw.');
            return;
          }
          const cart = await fetch(root + 'cart.js')
            .then((r) => r.json())
            .catch(() => null);
          this.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart || { item_count: 0 },
                sourceId: 'velaine-cart-upsell',
                data: { source: 'velaine-cart-upsell', itemCount: 1, variantId: String(variant.id), sections: data.sections },
              },
            })
          );
        } catch (error) {
          console.error(error);
          this.message(card, 'Toevoegen lukte niet. Probeer het opnieuw.');
        } finally {
          this.busy = false;
          button.removeAttribute('aria-busy');
        }
      }
    }
  );
})();
